import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* listContactSupport(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SUPPORT.LIST, action.payload, true);
}

function* updateContactSupportStatus(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SUPPORT.UPDATE_STATUS(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.PUT, url, rest, true);
}

function* replyContactSupport(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SUPPORT.REPLY(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.POST, url, rest, true);
}

function* listExperienceRatings(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SUPPORT.RATINGS_LIST, action.payload, true);
}

function* replyExperienceRating(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SUPPORT.RATINGS_REPLY(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.POST, url, rest, true);
}

function* markExperienceRatingReviewed(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.SUPPORT.RATINGS_MARK_REVIEW(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.PATCH, url, rest, true);
}

export default function* adminSupportSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.LIST, listContactSupport);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.UPDATE_STATUS, updateContactSupportStatus);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.REPLY, replyContactSupport);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.RATINGS_LIST, listExperienceRatings);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.RATINGS_REPLY, replyExperienceRating);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SUPPORT.RATINGS_MARK_REVIEW, markExperienceRatingReviewed);
}
